// 定义接口请求超时处理函数
const requestTimeout = (second: number) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(new Response(null, {
        status: 504,
        statusText: 'timeout',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    }, second);
  });
};

export default requestTimeout;
